import { CheckCircle2, XCircle } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import type { DependencyInfo } from './useProductPanel';

interface RequirementsSectionProps {
  dependencies: DependencyInfo[];
}

export function RequirementsSection({ dependencies }: RequirementsSectionProps) {
  if (dependencies.length === 0) return null;

  return (
    <div>
      <span className="text-xs font-bold uppercase tracking-wide text-gray-400">
        <Trans>Requirements</Trans>
      </span>
      <div className="mt-3 space-y-2">
        {dependencies.map(({ productTypeName, isActive }) => (
          <div
            key={productTypeName}
            className="flex items-center gap-3 rounded-xl border border-gray-200 px-4 py-2.5"
          >
            {isActive ? (
              <CheckCircle2 size={16} className="text-emerald-500 shrink-0" />
            ) : (
              <XCircle size={16} className="text-amber-500 shrink-0" />
            )}
            <span className="text-sm text-gray-700 flex-1">{productTypeName}</span>
            {!isActive && (
              <span className="text-xs text-amber-600 font-medium">
                <Trans>Required</Trans>
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
